export enum DateSelection {
  LastDay = 'Last Day',
  LastWeek = 'Last Week',
  LastMonth = 'Last Month',
  LastYear = 'Last Year',
  LastTwoYears = 'Last Two Years',
  CustomDateRange = 'Custom Date Range',
}
